import { call } from "redux-saga/effects";
import cirrusClient from "../../../services/api/cirrus-client";


export function* readConferenceParticipantsSaga(action) {
    try {
        const { conferenceUri } = action.payload;
        // API endpoint for reading participants in a conference session
        const apiUrl = `?object=participant&action=read&conference_match=${conferenceUri}`;

        // Make the API call with the credentials
        const response = yield call(cirrusClient.get, apiUrl);
        
        return response.data;

    } catch (error) {
        console.error('Error reading participants in the conference', error);
    }


}